var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var AnalyticsEventType = /* @__PURE__ */ ((AnalyticsEventType2) => {
  AnalyticsEventType2["ScreenView"] = "screen.view";
  AnalyticsEventType2["PlaybackPlay"] = "playback.play";
  AnalyticsEventType2["PlaybackPause"] = "playback.pause";
  AnalyticsEventType2["PlaybackResume"] = "playback.resume";
  AnalyticsEventType2["PlaybackSeekStart"] = "playback.seekStart";
  AnalyticsEventType2["PlaybackSeekComplete"] = "playback.seekComplete";
  AnalyticsEventType2["PlaybackBufferStart"] = "playback.bufferStart";
  AnalyticsEventType2["PlaybackBufferComplete"] = "playback.bufferComplete";
  AnalyticsEventType2["PlaybackComplete"] = "playback.complete";
  AnalyticsEventType2["PlaybackError"] = "playback.error";
  AnalyticsEventType2["PlaybackAdPodStart"] = "playback.adPodStart";
  AnalyticsEventType2["PlaybackAdPodComplete"] = "playback.adPodComplete";
  AnalyticsEventType2["PlaybackAdStart"] = "playback.adStart";
  AnalyticsEventType2["PlaybackAdComplete"] = "playback.adComplete";
  AnalyticsEventType2["PlaybackAdBreakStart"] = "playback.adBreakStart";
  AnalyticsEventType2["PlaybackAdBreakComplete"] = "playback.adBreakComplete";
  AnalyticsEventType2["PlaybackPercentages5"] = "playback.percentages.5";
  AnalyticsEventType2["PlaybackPercentages10"] = "playback.percentages.10";
  AnalyticsEventType2["PlaybackPercentages25"] = "playback.percentages.25";
  AnalyticsEventType2["PlaybackPercentages50"] = "playback.percentages.50";
  AnalyticsEventType2["PlaybackPercentages75"] = "playback.percentages.75";
  AnalyticsEventType2["PlaybackPercentages90"] = "playback.percentages.90";
  AnalyticsEventType2["PlaybackPercentages100"] = "playback.percentages.100";
  AnalyticsEventType2["PlaybackAdClick"] = "playback.adClick";
  AnalyticsEventType2["PlaybackHeartbeat"] = "playback.heartbeat";
  AnalyticsEventType2["PlaybackQualityChange"] = "playback.qualityChange";
  AnalyticsEventType2["PlaybackStop"] = "playback.stop";
  AnalyticsEventType2["ActionBuy"] = "action.buy";
  AnalyticsEventType2["ActionDownloadsAdd"] = "action.downloadsAdd";
  AnalyticsEventType2["ActionDownloadsRemove"] = "action.downloadsRemove";
  AnalyticsEventType2["ActionFavoritesAdd"] = "action.favoritesAdd";
  AnalyticsEventType2["ActionFavoritesRemove"] = "action.favoritesRemove";
  AnalyticsEventType2["ActionLocaleChange"] = "action.localeChange";
  AnalyticsEventType2["ActionLogin"] = "action.login";
  AnalyticsEventType2["ActionSecondScreenLogin"] = "action.secondScreenLogin";
  AnalyticsEventType2["ActionLogout"] = "action.logout";
  AnalyticsEventType2["ActionRegister"] = "action.register";
  AnalyticsEventType2["ActionSearch"] = "action.search";
  AnalyticsEventType2["ActionShare"] = "action.share";
  AnalyticsEventType2["ActionCcpa"] = "action.ccpaChange";
  AnalyticsEventType2["ActionConsent"] = "action.consentUpdate";
  AnalyticsEventType2["ActionEnableParentalPin"] = "action.enableParentalPin";
  AnalyticsEventType2["ActionDisableParentalPin"] = "action.disableParentalPin";
  AnalyticsEventType2["TechInit"] = "tech.init";
  AnalyticsEventType2["TechPlaybackPositionChange"] = "tech.playbackPositionChange";
  AnalyticsEventType2["TechSetPlayer"] = "tech.setPlayer";
  AnalyticsEventType2["TechSetAdContexts"] = "tech.setAdContexts";
  AnalyticsEventType2["TechUpNext"] = "tech.upNext";
  return AnalyticsEventType2;
})(AnalyticsEventType || {});
var ScreenType = /* @__PURE__ */ ((ScreenType2) => {
  ScreenType2["Browse"] = "browse";
  ScreenType2["Details"] = "details";
  ScreenType2["Search"] = "search";
  ScreenType2["Login"] = "login";
  ScreenType2["Register"] = "register";
  ScreenType2["Buy"] = "buy";
  ScreenType2["ProgramList"] = "programList";
  ScreenType2["More"] = "more";
  ScreenType2["WatchHistory"] = "watchHistory";
  ScreenType2["UnauthenticatedHome"] = "unauthenticatedHome";
  return ScreenType2;
})(ScreenType || {});
var ReceiptStatus = /* @__PURE__ */ ((ReceiptStatus2) => {
  ReceiptStatus2["Successful"] = "successful";
  ReceiptStatus2["Pending"] = "pending";
  ReceiptStatus2["Unsuccesful"] = "unsuccessful";
  return ReceiptStatus2;
})(ReceiptStatus || {});
var SeekDirection = /* @__PURE__ */ ((SeekDirection2) => {
  SeekDirection2["Forward"] = "forward";
  SeekDirection2["Backward"] = "backward";
  return SeekDirection2;
})(SeekDirection || {});
var AnalyticsEventParam = /* @__PURE__ */ ((AnalyticsEventParam2) => {
  AnalyticsEventParam2["AppName"] = "appName";
  AnalyticsEventParam2["AppVersion"] = "appVersion";
  AnalyticsEventParam2["BrowserName"] = "browserName";
  AnalyticsEventParam2["BrowserVersion"] = "browserVersion";
  AnalyticsEventParam2["DeviceId"] = "deviceId";
  AnalyticsEventParam2["PlatformDeviceId"] = "platformDeviceId";
  AnalyticsEventParam2["PlatformDeviceType"] = "platformDeviceType";
  AnalyticsEventParam2["PlatformMake"] = "platformMake";
  AnalyticsEventParam2["PlatformModel"] = "platformModel";
  AnalyticsEventParam2["PlatformOs"] = "platformOs";
  AnalyticsEventParam2["PlatformOsVersion"] = "platformOsVersion";
  AnalyticsEventParam2["PlatformType"] = "platformType";
  AnalyticsEventParam2["PlatformUserAgent"] = "platformUserAgent";
  AnalyticsEventParam2["ScreenResolution"] = "screenResolution";
  AnalyticsEventParam2["SiteDomain"] = "siteDomain";
  AnalyticsEventParam2["SiteUrl"] = "siteUrl";
  AnalyticsEventParam2["UserId"] = "userId";
  AnalyticsEventParam2["UserProfile"] = "userProfile";
  AnalyticsEventParam2["Mvpd"] = "mvpd";
  AnalyticsEventParam2["ScreenTitle"] = "screenTitle";
  AnalyticsEventParam2["ScreenType"] = "screenType";
  AnalyticsEventParam2["AdId"] = "adId";
  AnalyticsEventParam2["AdPodId"] = "adPodId";
  AnalyticsEventParam2["AdPosition"] = "adPosition";
  AnalyticsEventParam2["AdType"] = "adType";
  AnalyticsEventParam2["AirDate"] = "airDate";
  AnalyticsEventParam2["Bitrate"] = "bitrate";
  AnalyticsEventParam2["ChannelName"] = "channelName";
  AnalyticsEventParam2["ContentId"] = "contentId";
  AnalyticsEventParam2["Description"] = "description";
  AnalyticsEventParam2["EpisodeNumber"] = "episodeNumber";
  AnalyticsEventParam2["Extras"] = "extras";
  AnalyticsEventParam2["FrameRate"] = "frameRate";
  AnalyticsEventParam2["FullEpisode"] = "fullEpisode";
  AnalyticsEventParam2["Fullscreen"] = "fullscreen";
  AnalyticsEventParam2["Genre"] = "genre";
  AnalyticsEventParam2["HasAds"] = "hasAds";
  AnalyticsEventParam2["Length"] = "length";
  AnalyticsEventParam2["LiveStream"] = "liveStream";
  AnalyticsEventParam2["Position"] = "position";
  AnalyticsEventParam2["Program"] = "program";
  AnalyticsEventParam2["PublishDate"] = "publishDate";
  AnalyticsEventParam2["Publisher"] = "publisher";
  AnalyticsEventParam2["Quality"] = "quality";
  AnalyticsEventParam2["SeasonNumber"] = "seasonNumber";
  AnalyticsEventParam2["SeekTime"] = "seekTime";
  AnalyticsEventParam2["SeekDirection"] = "seekDirection";
  AnalyticsEventParam2["SessionId"] = "sessionId";
  AnalyticsEventParam2["Subtype"] = "subtype";
  AnalyticsEventParam2["Title"] = "title";
  AnalyticsEventParam2["TvShowTitle"] = "tvShowTitle";
  AnalyticsEventParam2["VideoPlayer"] = "videoPlayer";
  AnalyticsEventParam2["Volume"] = "volume";
  AnalyticsEventParam2["ErrorMessage"] = "errorMessage";
  AnalyticsEventParam2["VideoUrl"] = "videoUrl";
  AnalyticsEventParam2["RegistrationDate"] = "registrationDate";
  AnalyticsEventParam2["Price"] = "price";
  AnalyticsEventParam2["Currency"] = "currency";
  AnalyticsEventParam2["TransactionId"] = "transactionId";
  AnalyticsEventParam2["SubscriptionPlan"] = "subscriptionPlan";
  AnalyticsEventParam2["ReceiptStatus"] = "receiptStatus";
  AnalyticsEventParam2["Store"] = "store";
  AnalyticsEventParam2["SearchQuery"] = "searchQuery";
  AnalyticsEventParam2["PlayerInstance"] = "techPlayerInstance";
  AnalyticsEventParam2["PlayerFrameworkInstance"] = "techPlayerFrameworkInstance";
  AnalyticsEventParam2["AdContextsInstance"] = "techAdContextsInstance";
  AnalyticsEventParam2["GoogleDaiStreamManagerInstance"] = "techGoogleDaiStreamManagerInstance";
  AnalyticsEventParam2["Analytics"] = "analytics";
  AnalyticsEventParam2["CcpaOptOut"] = "ccpaOptOut";
  AnalyticsEventParam2["Consent"] = "consent";
  AnalyticsEventParam2["Id3Tag"] = "id3tag";
  return AnalyticsEventParam2;
})(AnalyticsEventParam || {});
const analyticsApiFallback = {
  sendEvent: () => {
    console.log("Analytics API is not available.");
  }
};
const defaultCommonContext = {
  ["appName" /* AppName */]: null,
  ["appVersion" /* AppVersion */]: null,
  ["browserName" /* BrowserName */]: null,
  ["browserVersion" /* BrowserVersion */]: null,
  ["deviceId" /* DeviceId */]: null,
  ["platformDeviceId" /* PlatformDeviceId */]: null,
  ["mvpd" /* Mvpd */]: null,
  ["platformDeviceType" /* PlatformDeviceType */]: null,
  ["platformMake" /* PlatformMake */]: null,
  ["platformModel" /* PlatformModel */]: null,
  ["platformOs" /* PlatformOs */]: null,
  ["platformOsVersion" /* PlatformOsVersion */]: null,
  ["platformType" /* PlatformType */]: null,
  ["platformUserAgent" /* PlatformUserAgent */]: null,
  ["screenResolution" /* ScreenResolution */]: null,
  ["siteDomain" /* SiteDomain */]: null,
  ["siteUrl" /* SiteUrl */]: null,
  ["userId" /* UserId */]: null
};
const commonContextParams = Object.keys(defaultCommonContext);
const createAnalyticsContext = () => {
  return Object.values(AnalyticsEventParam).reduce((analytics, param) => {
    analytics[param] = null;
    return analytics;
  }, {});
};
const determineVideoQuality = (width, height) => {
  if (!width || !height) {
    return null;
  }
  if (width < 1280 && height < 720) {
    return "SD" /* SD */;
  }
  if (width < 1920 && height < 1080) {
    return "720" /* HD */;
  }
  if (width < 3840 && height < 2160) {
    return "1080" /* FHD */;
  }
  return "4K" /* UHD */;
};
const convertDateToString = (date) => {
  return date.toISOString();
};
const flatAnalyticsPayload = (payload) => {
  const _a = payload, { customParams, commonContext } = _a, rest = __objRest(_a, ["customParams", "commonContext"]);
  return __spreadValues(__spreadValues(__spreadValues({}, rest), commonContext), customParams);
};
const analyticsBindingMapping = {
  "ad.id": "adId" /* AdId */,
  "ad.pod.id": "adPodId" /* AdPodId */,
  "ad.position": "adPosition" /* AdPosition */,
  "ad.type": "adType" /* AdType */,
  "app.name": "appName" /* AppName */,
  "app.version": "appVersion" /* AppVersion */,
  "browser.name": "browserName" /* BrowserName */,
  "browser.version": "browserVersion" /* BrowserVersion */,
  "item.airDate": "airDate" /* AirDate */,
  "item.channelName": "channelName" /* ChannelName */,
  "item.extras": "extras" /* Extras */,
  "item.id": "contentId" /* ContentId */,
  "item.description": "description" /* Description */,
  "item.episodeNumber": "episodeNumber" /* EpisodeNumber */,
  "item.frameRate": "frameRate" /* FrameRate */,
  "item.fullEpisode": "fullEpisode" /* FullEpisode */,
  "item.genre": "genre" /* Genre */,
  "item.hasAds": "hasAds" /* HasAds */,
  "item.length": "length" /* Length */,
  "item.isLive": "liveStream" /* LiveStream */,
  "item.program": "program" /* Program */,
  "item.publishDate": "publishDate" /* PublishDate */,
  "item.publisher": "publisher" /* Publisher */,
  "item.seasonNumber": "seasonNumber" /* SeasonNumber */,
  "item.subtype": "subtype" /* Subtype */,
  "item.title": "title" /* Title */,
  "item.tvShow.title": "tvShowTitle" /* TvShowTitle */,
  "platform.deviceType": "platformDeviceType" /* PlatformDeviceType */,
  "platform.make": "platformMake" /* PlatformMake */,
  "platform.model": "platformModel" /* PlatformModel */,
  "platform.os": "platformOs" /* PlatformOs */,
  "platform.osVersion": "platformOsVersion" /* PlatformOsVersion */,
  "platform.resolution": "screenResolution" /* ScreenResolution */,
  "platform.type": "platformType" /* PlatformType */,
  "platform.userAgent": "platformUserAgent" /* PlatformUserAgent */,
  "platform.uuid": "deviceId" /* DeviceId */,
  // TODO: change to `platform.deviceId`
  "platform.deviceId": "platformDeviceId" /* PlatformDeviceId */,
  "player.bitrate": "bitrate" /* Bitrate */,
  "player.fullscreen": "fullscreen" /* Fullscreen */,
  "player.position": "position" /* Position */,
  "player.seekTime": "seekTime" /* SeekTime */,
  "player.seekDirection": "seekDirection" /* SeekDirection */,
  "player.quality": "quality" /* Quality */,
  "player.vendorName": "videoPlayer" /* VideoPlayer */,
  "player.volume": "volume" /* Volume */,
  "player.videoUrl": "videoUrl" /* VideoUrl */,
  "purchase.currency": "currency" /* Currency */,
  "purchase.price": "price" /* Price */,
  "purchase.receiptStatus": "receiptStatus" /* ReceiptStatus */,
  "purchase.store": "store" /* Store */,
  "purchase.subscriptionPlan": "subscriptionPlan" /* SubscriptionPlan */,
  "purchase.transactionId": "transactionId" /* TransactionId */,
  "registration.date": "registrationDate" /* RegistrationDate */,
  "screen.title": "screenTitle" /* ScreenTitle */,
  "screen.type": "screenType" /* ScreenType */,
  "searchResults.searchQuery": "searchQuery" /* SearchQuery */,
  "site.domain": "siteDomain" /* SiteDomain */,
  "site.url": "siteUrl" /* SiteUrl */,
  "user.id": "userId" /* UserId */,
  "user.mvpd": "mvpd" /* Mvpd */,
  "user.sessionId": "sessionId" /* SessionId */,
  "user.profile": "userProfile" /* UserProfile */,
  ccpaOptOut: "ccpaOptOut" /* CcpaOptOut */,
  analytics: "analytics" /* Analytics */,
  id3tag: "id3tag" /* Id3Tag */
};
const constructUnTypedPayload = (params, valueOverrides, databinder, context, pluginId, event, initialPayload) => {
  return params.reduce((payload, param) => {
    let customValue = null;
    if (param in valueOverrides) {
      customValue = valueOverrides[param];
      if (typeof customValue === "string") {
        customValue = databinder(customValue, context, pluginId);
      }
    }
    if (param in context) {
      const nativeParam = param;
      Object.assign(
        commonContextParams.includes(nativeParam) ? payload.commonContext : payload,
        {
          [param]: customValue === null ? context[nativeParam] : customValue
        }
      );
    } else if (customValue === null) {
      console.warn(
        `${pluginId} - Invalid config key "${param}" received from "${event}" event.`
      );
    } else {
      payload.customParams[param] = customValue;
    }
    return payload;
  }, initialPayload);
};
const createAnalyticsPayload = ({
  config,
  event: { detail },
  context,
  pluginId = "UnknownPlugin",
  // only needed for logging
  databinder = defaultDatabinder,
  updateClientContext,
  useTypedBindings = false
}) => {
  var _a, _b;
  const { event, payload, isTechnical } = detail;
  const commonContext = constructCommonContextPayload(
    config,
    context,
    databinder,
    pluginId,
    event,
    payload,
    updateClientContext,
    useTypedBindings
  );
  if (isTechnical) {
    return commonContext;
  }
  const { valueOverrides = {}, properties = {} } = config;
  const initialPayload = {
    customParams: {},
    commonContext: __spreadValues(__spreadValues({}, defaultCommonContext), commonContext.commonContext)
  };
  if (useTypedBindings) {
    const bindedParamsByTypes = (_a = Object.keys(properties)) == null ? void 0 : _a.reduce(
      (acc, curr) => {
        acc[curr] = bindPropertiesWithTypes(
          properties[curr],
          context,
          databinder,
          pluginId
        );
        return acc;
      },
      {}
    );
    initialPayload.customParams = bindedParamsByTypes;
    return initialPayload;
  }
  const configParams = (_b = config.events) == null ? void 0 : _b[event];
  if (!configParams) {
    console.warn(`${pluginId} - Event "${event}" doesn't exist in config.`);
    return initialPayload;
  }
  const params = [...commonContextParams, ...configParams];
  return constructUnTypedPayload(
    params,
    valueOverrides,
    databinder,
    context,
    pluginId,
    event,
    initialPayload
  );
};
const bindPropertiesWithTypes = (properties, context, databinder = defaultDatabinder, pluginId) => {
  const [type] = Object.keys(properties);
  let value = databinder(properties[type], context, pluginId);
  switch (type) {
    case "string":
      value = String(databinder(properties[type], context, pluginId));
      break;
    case "boolean":
      value = JSON.parse(
        databinder(properties[type], context, pluginId) || "false"
      );
      break;
    case "number":
      value = Number(databinder(properties[type], context, pluginId));
      break;
    case "object":
      value = typeof databinder(properties[type], context, pluginId) === "string" ? JSON.parse(databinder(properties[type], context, pluginId) || "{}") : databinder(properties[type], context, pluginId);
      break;
    case "array":
      value = Array.isArray(databinder(properties[type], context, pluginId)) ? databinder(properties[type], context, pluginId) : JSON.parse(databinder(properties[type], context, pluginId) || "{}");
      break;
  }
  return value;
};
const constructCommonContextPayload = (config, context, databinder, pluginId, event, payload, updateClientContext, useUpdatedStructuredEvents = false) => {
  const { customMetadata = {}, valueOverrides = {}, properties = {} } = config;
  const commonContext = commonContextParams.reduce(
    (commonContext2, param) => {
      if (useUpdatedStructuredEvents) {
        commonContext2[param] = (properties == null ? void 0 : properties[param]) ? bindPropertiesWithTypes(
          properties[param],
          context,
          databinder,
          pluginId
        ) : context == null ? void 0 : context[param];
        return commonContext2;
      }
      commonContext2[param] = context == null ? void 0 : context[param];
      if (param in valueOverrides && (valueOverrides == null ? void 0 : valueOverrides[param])) {
        const customValue = valueOverrides[param];
        commonContext2[param] = databinder(customValue, context, pluginId);
      }
      return commonContext2;
    },
    __spreadValues({}, defaultCommonContext)
  );
  return event === "tech.setPlayer" /* TechSetPlayer */ ? {
    ["techPlayerInstance" /* PlayerInstance */]: (
      // TODO: "payload.payload" - wrong type, fix this later
      payload["techPlayerInstance" /* PlayerInstance */]
    ),
    ["techPlayerFrameworkInstance" /* PlayerFrameworkInstance */]: payload["techPlayerFrameworkInstance" /* PlayerFrameworkInstance */],
    ["techGoogleDaiStreamManagerInstance" /* GoogleDaiStreamManagerInstance */]: payload["techGoogleDaiStreamManagerInstance" /* GoogleDaiStreamManagerInstance */],
    ["techAdContextsInstance" /* AdContextsInstance */]: payload["techAdContextsInstance" /* AdContextsInstance */],
    customParams: Object.entries(customMetadata).reduce(
      (metadata, [key, value]) => {
        metadata[key] = databinder(value, context, pluginId);
        return metadata;
      },
      {}
    ),
    commonContext,
    updateClientContext
  } : __spreadProps(__spreadValues({}, payload), {
    customParams: {},
    commonContext,
    updateClientContext
  });
};
const defaultDatabinder = (pattern, context, pluginId) => {
  return pattern.replace(/{{\s*(.*?)\s*}}/g, (match, binding) => {
    const [, extraKey] = binding.match(/item.extras.(.*)/) || [];
    const contextKey = analyticsBindingMapping[binding];
    const result = extraKey ? context["extras" /* Extras */][extraKey] : context[contextKey];
    if (!result && (extraKey || !contextKey)) {
      console.warn(
        `${pluginId} - Couldn't replace ${match} as no matching context key was found.`
      );
      return match;
    }
    return typeof result === "object" ? JSON.stringify(result) : String(result);
  });
};
class AnalyticsEventBase extends CustomEvent {
  constructor(event, payload, isTechnical = false) {
    super("analytics", {
      detail: {
        event,
        payload,
        isTechnical
      }
    });
  }
  initCustomEvent(typeArg, canBubble, cancelable, detail) {
    super.initCustomEvent("analytics", canBubble, cancelable, detail);
  }
}
class AnalyticsEvent extends AnalyticsEventBase {
}
class AnalyticsScreenViewEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("screen.view" /* ScreenView */, payload);
  }
}
class AnalyticsPlaybackPlayEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.play" /* PlaybackPlay */, payload);
  }
}
class AnalyticsPlaybackPauseEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.pause" /* PlaybackPause */, payload);
  }
}
class AnalyticsPlaybackResumeEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.resume" /* PlaybackResume */, payload);
  }
}
class AnalyticsPlaybackSeekStartEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.seekStart" /* PlaybackSeekStart */, payload);
  }
}
class AnalyticsPlaybackSeekCompleteEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.seekComplete" /* PlaybackSeekComplete */, payload);
  }
}
class AnalyticsPlaybackBufferStartEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.bufferStart" /* PlaybackBufferStart */, payload);
  }
}
class AnalyticsPlaybackBufferCompleteEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.bufferComplete" /* PlaybackBufferComplete */, payload);
  }
}
class AnalyticsPlaybackCompleteEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.complete" /* PlaybackComplete */, payload);
  }
}
class AnalyticsPlaybackAdPodStartEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.adPodStart" /* PlaybackAdPodStart */, payload);
  }
}
class AnalyticsPlaybackAdPodCompleteEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.adPodComplete" /* PlaybackAdPodComplete */, payload);
  }
}
class AnalyticsPlaybackAdStartEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.adStart" /* PlaybackAdStart */, payload);
  }
}
class AnalyticsPlaybackAdCompleteEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.adComplete" /* PlaybackAdComplete */, payload);
  }
}
class AnalyticsPlaybackAdBreakStartEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.adBreakStart" /* PlaybackAdBreakStart */, payload);
  }
}
class AnalyticsPlaybackAdBreakCompleteEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.adBreakComplete" /* PlaybackAdBreakComplete */, payload);
  }
}
class AnalyticsPlaybackAdClickEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.adClick" /* PlaybackAdClick */, payload);
  }
}
class AnalyticsPlaybackHeartbeatEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.heartbeat" /* PlaybackHeartbeat */, payload);
  }
}
class AnalyticsPlaybackQualityChangeEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.qualityChange" /* PlaybackQualityChange */, payload);
  }
}
class AnalyticsPlaybackStopEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.stop" /* PlaybackStop */, payload);
  }
}
class AnalyticsPlaybackErrorEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.error" /* PlaybackError */, payload);
  }
}
class AnalyticsActionBuyEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("action.buy" /* ActionBuy */, payload);
  }
}
class AnalyticsActionFavoritesAddEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("action.favoritesAdd" /* ActionFavoritesAdd */, payload);
  }
}
class AnalyticsActionFavoritesRemoveEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("action.favoritesRemove" /* ActionFavoritesRemove */, payload);
  }
}
class AnalyticsActionSearchEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("action.search" /* ActionSearch */, payload);
  }
}
class AnalyticsActionRegisterEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("action.register" /* ActionRegister */, payload);
  }
}
class AnalyticsActionLoginEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("action.login" /* ActionLogin */, payload);
  }
}
class AnalyticsActionSecondScreenLoginEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("action.secondScreenLogin" /* ActionSecondScreenLogin */, payload);
  }
}
class AnalyticsActionLogoutEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("action.logout" /* ActionLogout */, payload);
  }
}
class AnalyticsActionShareEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("action.share" /* ActionShare */, payload);
  }
}
class AnalyticsActionCcpaEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("action.ccpaChange" /* ActionCcpa */, payload);
  }
}
class AnalyticsActionConsentEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("action.consentUpdate" /* ActionConsent */, payload);
  }
}
class AnalyticsTechInitEvent extends AnalyticsEventBase {
  constructor() {
    super("tech.init" /* TechInit */, {}, true);
  }
}
class AnalyticsTechPlaybackPositionChangeEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("tech.playbackPositionChange" /* TechPlaybackPositionChange */, payload, true);
  }
}
class AnalyticsTechUpNextEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("tech.upNext" /* TechUpNext */, payload, true);
  }
}
class AnalyticsTechSetPlayerEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("tech.setPlayer" /* TechSetPlayer */, payload, true);
  }
}
class AnalyticsTechSetAdContextsEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("tech.setAdContexts" /* TechSetAdContexts */, payload, true);
  }
}
class AnalyticsActionEnableParentalPinEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("action.enableParentalPin" /* ActionEnableParentalPin */, payload, true);
  }
}
class AnalyticsActionDisableParentalPinEvent extends AnalyticsEventBase {
  constructor(payload) {
    super("action.disableParentalPin" /* ActionDisableParentalPin */, payload, true);
  }
}
class AnalyticsPlaybackPercentages5Event extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.percentages.5" /* PlaybackPercentages5 */, payload, false);
  }
}
class AnalyticsPlaybackPercentages10Event extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.percentages.10" /* PlaybackPercentages10 */, payload, false);
  }
}
class AnalyticsPlaybackPercentages25Event extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.percentages.25" /* PlaybackPercentages25 */, payload, false);
  }
}
class AnalyticsPlaybackPercentages50Event extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.percentages.50" /* PlaybackPercentages50 */, payload, false);
  }
}
class AnalyticsPlaybackPercentages75Event extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.percentages.75" /* PlaybackPercentages75 */, payload, false);
  }
}
class AnalyticsPlaybackPercentages90Event extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.percentages.90" /* PlaybackPercentages90 */, payload, false);
  }
}
class AnalyticsPlaybackPercentages100Event extends AnalyticsEventBase {
  constructor(payload) {
    super("playback.percentages.100" /* PlaybackPercentages100 */, payload, false);
  }
}

export { AnalyticsActionBuyEvent, AnalyticsActionCcpaEvent, AnalyticsActionConsentEvent, AnalyticsActionDisableParentalPinEvent, AnalyticsActionEnableParentalPinEvent, AnalyticsActionFavoritesAddEvent, AnalyticsActionFavoritesRemoveEvent, AnalyticsActionLoginEvent, AnalyticsActionLogoutEvent, AnalyticsActionRegisterEvent, AnalyticsActionSearchEvent, AnalyticsActionSecondScreenLoginEvent, AnalyticsActionShareEvent, AnalyticsEvent, AnalyticsEventParam, AnalyticsEventType, AnalyticsPlaybackAdBreakCompleteEvent, AnalyticsPlaybackAdBreakStartEvent, AnalyticsPlaybackAdClickEvent, AnalyticsPlaybackAdCompleteEvent, AnalyticsPlaybackAdPodCompleteEvent, AnalyticsPlaybackAdPodStartEvent, AnalyticsPlaybackAdStartEvent, AnalyticsPlaybackBufferCompleteEvent, AnalyticsPlaybackBufferStartEvent, AnalyticsPlaybackCompleteEvent, AnalyticsPlaybackErrorEvent, AnalyticsPlaybackHeartbeatEvent, AnalyticsPlaybackPauseEvent, AnalyticsPlaybackPercentages100Event, AnalyticsPlaybackPercentages10Event, AnalyticsPlaybackPercentages25Event, AnalyticsPlaybackPercentages50Event, AnalyticsPlaybackPercentages5Event, AnalyticsPlaybackPercentages75Event, AnalyticsPlaybackPercentages90Event, AnalyticsPlaybackPlayEvent, AnalyticsPlaybackQualityChangeEvent, AnalyticsPlaybackResumeEvent, AnalyticsPlaybackSeekCompleteEvent, AnalyticsPlaybackSeekStartEvent, AnalyticsPlaybackStopEvent, AnalyticsScreenViewEvent, AnalyticsTechInitEvent, AnalyticsTechPlaybackPositionChangeEvent, AnalyticsTechSetAdContextsEvent, AnalyticsTechSetPlayerEvent, AnalyticsTechUpNextEvent, ReceiptStatus, ScreenType, SeekDirection, analyticsApiFallback, analyticsBindingMapping, bindPropertiesWithTypes, convertDateToString, createAnalyticsContext, createAnalyticsPayload, defaultDatabinder, determineVideoQuality, flatAnalyticsPayload };
